import React, { Component } from "react";
import { connect } from 'react-redux';
import { getSeferListesi, kurBilgileriniListele, setRecaptchaResponse, initializeCookie } from "../../actions/Actions";
import LoadingOverlay from "./LoadingOverlay";
import LimanDropDown from "./LimanDropDown";
import BaslangicTarih from "./BaslangicTarih";
import BitisTarih from "./BitisTarih";
import TicaretTipiDropDown from "./TicaretTipiDropDown";
import GuncelKur from "./GuncelKur";
import GemiAdiInput from "./GemiAdiInput";
import SeferListesi from "./SeferListesi";
import ReCAPTCHA from 'react-google-recaptcha';
import { Grid, Row, Col, Button } from "react-bootstrap";

class MainForm extends Component {
    componentDidMount() {
        this.props.kurBilgileriniListele();

        initializeCookie();
    }

    handleSubmit(event) {
        event.preventDefault();

        const { recaptchaResponse, baslangicTarihi, bitisTarihi, limanId, ticaretTipi, gemiAdı } = this.props;

        this.props.getSeferListesi(recaptchaResponse, baslangicTarihi, bitisTarihi, limanId, ticaretTipi, gemiAdı);
    }

    render() {
        const { recaptchaResponse, guncelKur, seferler } = this.props;

        let guncelKurDiv;

        // Güncel kur listesi doluysa, kur tablosu gösteriliyor.
        if (guncelKur.length !== 0) {
            guncelKurDiv =
                <Col xs={6}>
                    <h5>Güncel Kur</h5>
                    <GuncelKur />
                </Col>;
        }

        let seferListesi;

        if (seferler.length !== 0) {
            seferListesi = <SeferListesi />;
        }

        let submitDiv;

        if (recaptchaResponse === "") {
            submitDiv =
                <Col xs={6} xsOffset={3}>
                    <ReCAPTCHA
                        ref="recaptcha"
                        sitekey="6LeiLmkUAAAAAGw7yy23V--Xc2h2mwcVOGGoyeoI"
                        onChange={this.props.setRecaptchaResponse} />
                </Col>
        }
        else {
            submitDiv =
                <Button type="submit" bsStyle="primary">
                    Seferleri Listele
                </Button>;
        }

        return (
            <div>
                <Grid>
                    <form method="POST" onSubmit={this.handleSubmit.bind(this)}>
                        <Col md={8} mdOffset={2} xs={12}>
                            <LoadingOverlay />
                            <div className="mainForm">
                                <Row>
                                    <Col xs={6}>
                                        <h5>Liman Seçiniz:</h5>
                                        <LimanDropDown />
                                    </Col>

                                    {guncelKurDiv}
                                </Row>

                                <Row>
                                    <Col xs={6}>
                                        <h5>Başlangıç Tarihi:</h5>
                                        <BaslangicTarih />
                                    </Col>
                                    <Col xs={6}>
                                        <h5>Bitiş Tarihi:</h5>
                                        <BitisTarih />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={6}>
                                        <h5>Gemi Adı:</h5>
                                        <GemiAdiInput />
                                    </Col>
                                    <Col xs={6}>
                                        <h5>Ticaret Tipi:</h5>
                                        <TicaretTipiDropDown />
                                    </Col>
                                </Row>
                                <hr />
                                <Row className="text-center">
                                    {submitDiv}
                                </Row>
                                <Row>
                                    <Col xs={12}>
                                        {seferListesi}
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </form>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    baslangicTarihi: state.reducer.baslangicTarihi,
    bitisTarihi: state.reducer.bitisTarihi,
    ticaretTipi: state.reducer.ticaretTipi,
    limanId: state.reducer.limanId,
    gemiAdı: state.reducer.gemiAdı,
    seferler: state.reducer.seferler,
    guncelKur: state.reducer.guncelKur,
    recaptchaResponse: state.reducer.recaptchaResponse
});

const mapDispatchToProps = dispatch => ({
    getSeferListesi: (recaptchaResponse, baslangicTarihi, bitisTarihi, limanId, ticaretTipi, gemiAdı) => { getSeferListesi(dispatch, recaptchaResponse, baslangicTarihi, bitisTarihi, limanId, ticaretTipi, gemiAdı); },
    kurBilgileriniListele: () => { kurBilgileriniListele(dispatch); },
    setRecaptchaResponse: (recaptchaResponse) => { setRecaptchaResponse(dispatch, recaptchaResponse); }
});

export default connect(mapStateToProps, mapDispatchToProps)(MainForm);


// WEBPACK FOOTER //
// ./src/components/containers/MainForm.js